import { render } from "./replyBar.vue?vue&type=template&id=2e4979e4&scoped=true"
import script from "./replyBar.vue?vue&type=script&lang=js"
export * from "./replyBar.vue?vue&type=script&lang=js"

import "./replyBar.vue?vue&type=style&index=0&id=2e4979e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4979e4"]])

export default __exports__